import mixins from 'vue-typed-mixins'

import Read from '@/views/treatment/ptsd/Read.vue'
import Schedule from '@/views/treatment/ptsd/Schedule.vue'
import Schedule2 from '@/views/treatment/ptsd/Schedule2.vue'
import Write from '@/views/treatment/ptsd/Write.vue'
import TreatmentMixin from '@/views/treatment/TreatmentMixin.ts'

import Await from './Await.vue'

export default mixins(TreatmentMixin).extend({
  components: {
    Await,
    Pcl5: () => import('@/survey/measures/pcl5/Pcl5.vue'),
    Read,
    Schedule,
    Schedule2,
    Write,
  },
})
